import { useTranslation } from 'react-i18next';
import { DESIGNERS, onDesignerColor } from './shared.js';
import type { DesignerId } from './shared.js';

interface FilterChipsProps {
  /** 現在のフィルタ (過去メンバー id も入りうるため string)。chip は現役デザイナーのみ表示 */
  active: string | null;
  onChange: (next: DesignerId | null) => void;
}

/**
 * 現役デザイナー + 「全部」をトグル可能な chip 群。CaseTable / DonutBlock のフィルタ連動に使う。
 *
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business CaseTable / DonutBlock を designer 単位で絞り込むためのフィルタ UI (chip 群)
 * @graph-connects none
 */
export function FilterChips({ active, onChange }: FilterChipsProps) {
  const { t } = useTranslation();
  const baseClass = 'px-2.5 py-1 rounded-full text-xs font-medium transition-colors border';
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      <button
        type="button"
        onClick={() => {
          onChange(null);
        }}
        className={`${baseClass} ${
          active === null
            ? 'border-transparent bg-[var(--color-text-primary)] text-[var(--color-bg-base)]'
            : 'border-[var(--color-border)] bg-[var(--color-bg-surface)] text-[var(--color-text-muted)] hover:border-[var(--color-border-hover)]'
        }`}
      >
        {t('idtKpi.caseDetail.filterAll')}
      </button>
      {DESIGNERS.map((d) => {
        const isActive = active === d.id;
        return (
          <button
            key={d.id}
            type="button"
            onClick={() => {
              onChange(isActive ? null : d.id);
            }}
            className={`${baseClass} ${
              isActive
                ? 'border-transparent'
                : 'border-[var(--color-border)] bg-[var(--color-bg-surface)] text-[var(--color-text-muted)] hover:border-[var(--color-border-hover)]'
            }`}
            style={
              isActive
                ? {
                    background: `var(${d.colorVar})`,
                    color: onDesignerColor(d.id),
                  }
                : undefined
            }
          >
            {d.id}
          </button>
        );
      })}
    </div>
  );
}
